import { render } from "./handwoven-silks-hero.vue?vue&type=template&id=6523d2e4&scoped=true"
import script from "./handwoven-silks-hero.vue?vue&type=script&lang=js"
export * from "./handwoven-silks-hero.vue?vue&type=script&lang=js"

import "./handwoven-silks-hero.vue?vue&type=style&index=0&id=6523d2e4&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6523d2e4"]])

export default __exports__